function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

module.exports = clamp;


//////////////////
// WEBPACK FOOTER
// ../~/_pure-color@1.3.0@pure-color/util/clamp.js
// module id = 256
// module chunks = 0